import { Box, Divider, Typography, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";
import { styled, useTheme } from "@mui/material/styles";
import WeddingDate from "./CompactWeddingDate";
import CompactWeddingDate from "./CompactWeddingDate";

const ImageContainer = styled("div")({
	width: 200,
	height: 200,
	borderRadius: "50%",
	border: "5px solid #B0DB9C",
	overflow: "hidden",
	marginRight: "20px",
});

const InfoContainer = styled("div")(({ theme }) => ({
	flex: 1,
	backgroundColor: theme.palette.accent.main,
	borderRadius: "10px",
	padding: "25px 20px",
}));

const ProfileSection = () => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.up("md"));

	const Image = styled("img")({
		width: "100%",
		height: "100%",
		maxWidth: matches ? "440px" : "300px",
		objectFit: "cover",
	});

	return (
		<Grid
			container
			spacing={2}
			sx={{ background: 'url("/background.png")', backgroundPosition: matches ? "center" : "" }}
			justifyContent={"center"}
		>
			<Grid
				mt={5}
				mb={5}
				p={4}
				item
				container
				size={{ xs: 12 }}
				sx={{
					textAlign: "center",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Box
					sx={{
						display: "flex",
						textAlign: "center",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						background: 'white',
						padding: "20px 25px",
						borderRadius: "20px",
					}}
				>
					<Typography variant="h2">Наши дорогие и близкие!</Typography>
					<Typography variant="h2">Приглашаем Вас на нашу</Typography>
					<Typography variant="h1">СВАДЬБУ</Typography>
				</Box>
			</Grid>
			<Grid item container size={{ xs: 12 }} justifyContent={"center"} mb={5}>
				<Image src="/us.png" />
			</Grid>
			<CompactWeddingDate />
		</Grid>
	);
};
export default ProfileSection;
